
export const URL_PREFIX = {
    AUTHENTICATE_USER: "authenticate_user",
    AUTHENTICATE_TOKEN: "authenticate_token",
    ITS_ME: "itsme",
    REFRESH_TOKEN: "refresh_token",
    LOG_OUT: "log_out",
    UPLOAD_MEDIA: "upload_media",
    GET_UPLOADED_MEDIA: "get_uploaded_media"
}
